<script setup lang="ts">

const { showPrivacy = false } = defineProps<{ showPrivacy?: boolean }>();

</script>

<template>
    <RouterLink to="/">Home</RouterLink>
    <!-- <RouterLink to="/how-it-works">How it Works</RouterLink> -->
    <RouterLink  
        to="/carbucks-rewards" 
        class="flex items-start leading-tight gap-x-1"
        :class="{ 'flex-col': showPrivacy == false }">
        <span>Carbucks</span>
        <span class="text-cyan-500 font-bold uppercase">Rewards</span>
    </RouterLink>
    <RouterLink 
        to="/carbucks-protect" 
        class="flex items-start leading-tight gap-x-1"
        :class="{ 'flex-col': showPrivacy == false }">
        <span>Carbucks</span>
        <span class="text-cyan-500 font-bold uppercase">Protect</span>
    </RouterLink>
    <RouterLink v-if="showPrivacy" to="/carbucks-privacy-policy">Privacy</RouterLink>
    <RouterLink v-if="showPrivacy" to="/carbucks-terms-of-service">Terms of Service</RouterLink>
    <RouterLink v-if="showPrivacy" to="/carbucks-app-end-user-license-agreement">EULA</RouterLink>
    <RouterLink v-if="showPrivacy" to="/tmd">Target Market Determination</RouterLink>
    <!-- <RouterLink v-if="showPrivacy" to="/smart-vehicle-health-monitor-order">Order Health Monitor</RouterLink> -->
    <a href="http://support.carbucks.com.au/help" target="_blank" >Help</a>
</template>